"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _assertThisInitialized = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
require("./AlignmentViewer.scss");
var AlignmentSorter_1 = require("../common/AlignmentSorter");
var ScrollSync_1 = require("../common/ScrollSync");
var SequenceLogoComponent_1 = require("./SequenceLogoComponent");
var SequenceBarplotComponent_1 = require("./SequenceBarplotComponent");
var MolecularStyles_1 = require("../common/MolecularStyles");
var MiniMapComponent_1 = require("./MiniMapComponent");
var AceMultipleSequenceAlignmentComponent_1 = require("./AceMultipleSequenceAlignmentComponent");
var AceConsensusSequenceComponent_1 = require("./AceConsensusSequenceComponent");
var AceQuerySequenceComponent_1 = require("./AceQuerySequenceComponent");
var AceTextualRulerComponent_1 = require("./AceTextualRulerComponent");
var AceEditorComponent_1 = require("./AceEditorComponent");
var defaultProps = {
  zoomLevel: 13,
  sortBy: AlignmentSorter_1.SequenceSorter.INPUT,
  showAnnotations: true,
  showConsensus: true,
  showLogo: true,
  showMinimap: false,
  showQuery: true,
  showRuler: true,
  logoOptions: {
    logoType: SequenceLogoComponent_1.LOGO_TYPES.LETTERS,
    height: "100px",
    tooltipPlacement: undefined
  },
  minimapOptions: {
    alignHorizontal: "right",
    startingWidth: 100,
    resizable: "horizontal",
    verticalHeight: "div"
  },
  //array of individual barplots. Each barplot can contain multiple
  //dataseries. Note that more than 2 dataseries in a single plot
  //is difficult to understand and more than 3 is pretty much impossible
  barplots: [{
    dataSeriesSet: [SequenceBarplotComponent_1.SequenceBarplotComponent.SHANNON_ENTROPY_BARPLOT, SequenceBarplotComponent_1.SequenceBarplotComponent.GAPS_BARPLOT],
    tooltipPlacement: undefined,
    height: "100px"
  }]
};
var ACE_EDITOR_IDS;
(function (ACE_EDITOR_IDS) {
  ACE_EDITOR_IDS["QUERY"] = "QUERY";
  ACE_EDITOR_IDS["CONSENSUS"] = "CONSENSUS";
  ACE_EDITOR_IDS["POSITIONAL_RULER"] = "POSITIONAL_RULER";
  ACE_EDITOR_IDS["MSA_SEQUENCES"] = "MSA_SEQUENCES";
  ACE_EDITOR_IDS["MSA_IDS"] = "MSA_IDS";
})(ACE_EDITOR_IDS || (ACE_EDITOR_IDS = {}));
var AlignmentViewer = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(AlignmentViewer, _react_1$default$Comp);
  function AlignmentViewer(props) {
    var _this;
    _classCallCheck(this, AlignmentViewer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlignmentViewer).call(this, props));
    _this.renderSequenceLogo = function () {
      var _this$props = _this.props,
        alignment = _this$props.alignment,
        logoOptions = _this$props.logoOptions,
        style = _this$props.style;
      var logoOpts = logoOptions ? logoOptions : defaultProps.logoOptions;
      return react_1.default.createElement("div", {
        className: "".concat(style.alignmentType.className, " ") + "".concat(style.colorScheme.className, " ") + "".concat(MolecularStyles_1.PositionsToStyle.ALL.className)
      }, react_1.default.createElement(SequenceLogoComponent_1.SequenceLogoComponent, {
        alignment: alignment,
        glyphWidth: _this.state.aceCharacterWidth,
        alignmentType: style.alignmentType,
        logoType: logoOpts.logoType,
        tooltipPlacement: logoOpts.tooltipPlacement,
        height: logoOpts.height
      }));
    };
    _this.renderBarplot = function (barplotProps) {
      return react_1.default.createElement(SequenceBarplotComponent_1.SequenceBarplotComponent, {
        alignment: _this.props.alignment,
        tooltipPlacement: barplotProps.tooltipPlacement,
        dataSeriesSet: barplotProps.dataSeriesSet,
        positionWidth: _this.state.aceCharacterWidth,
        height: barplotProps.height
      });
    };
    _this.renderConsensusQueryBox = function () {
      return react_1.default.createElement("div", {
        className: "consensusseq-box"
      }, react_1.default.createElement(AceConsensusSequenceComponent_1.AceConsensusSequenceComponent, {
        alignment: _this.props.alignment,
        fontSize: _this.props.zoomLevel ? _this.props.zoomLevel : defaultProps.zoomLevel,
        classNames: ["ace-consensusseq", _this.props.style.residueDetail.className, _this.props.style.alignmentType.className, _this.props.style.positionsToStyle.className, _this.props.style.colorScheme.className].join(" "),
        editorLoaded: function editorLoaded(editor, parentElem) {
          _this.aceEditorLoaded(ACE_EDITOR_IDS.CONSENSUS, editor, parentElem, ScrollSync_1.ScrollType.horizontal);
        }
      }));
    };
    _this.renderQuerySeqBox = function () {
      return react_1.default.createElement("div", {
        className: "queryseq-box"
      }, react_1.default.createElement(AceQuerySequenceComponent_1.AceQuerySequenceComponent, {
        alignment: _this.props.alignment,
        fontSize: _this.props.zoomLevel ? _this.props.zoomLevel : defaultProps.zoomLevel,
        sortBy: _this.props.sortBy ? _this.props.sortBy : defaultProps.sortBy,
        classNames: ["ace-queryseq", _this.props.style.residueDetail.className, _this.props.style.alignmentType.className, _this.props.style.positionsToStyle.className, _this.props.style.colorScheme.className].join(" "),
        editorLoaded: function editorLoaded(editor, parentElem) {
          _this.aceEditorLoaded(ACE_EDITOR_IDS.QUERY, editor, parentElem, ScrollSync_1.ScrollType.horizontal);
        }
      }));
    };
    _this.renderPositionBox = function () {
      return react_1.default.createElement("div", {
        className: "position-box"
      }, react_1.default.createElement(AceTextualRulerComponent_1.AceTextualRulerComponent, {
        classNames: "ace-positions",
        alignment: _this.props.alignment,
        fontSize: _this.props.zoomLevel ? _this.props.zoomLevel : defaultProps.zoomLevel,
        editorLoaded: function editorLoaded(editor, parentElem) {
          _this.aceEditorLoaded(ACE_EDITOR_IDS.POSITIONAL_RULER, editor, parentElem, ScrollSync_1.ScrollType.horizontal);
        }
      }));
    };
    _this.renderAlignmentBox = function () {
      return react_1.default.createElement("div", {
        className: "alignment-box"
      }, react_1.default.createElement(AceMultipleSequenceAlignmentComponent_1.AceMultipleSequenceAlignmentComponent, {
        alignment: _this.props.alignment,
        fontSize: _this.props.zoomLevel ? _this.props.zoomLevel : defaultProps.zoomLevel,
        sortBy: _this.props.sortBy ? _this.props.sortBy : defaultProps.sortBy,
        classNames: ["ace-alignment", _this.props.style.residueDetail.className, _this.props.style.alignmentType.className, _this.props.style.positionsToStyle.className, _this.props.style.colorScheme.className].join(" "),
        characterSizeChanged: _this.handleCharacterSizeChanged,
        editorLoaded: function editorLoaded(editor, parentElem) {
          _this.aceEditorLoaded(ACE_EDITOR_IDS.MSA_SEQUENCES, editor, parentElem, ScrollSync_1.ScrollType.both);
        }
      }));
    };
    _this.renderAlignmentAnnotationBox = function () {
      return react_1.default.createElement("div", {
        className: "alignment-metadata-box"
      }, react_1.default.createElement(AceEditorComponent_1.AceEditorComponent, {
        classNames: "ace-alignment-metadata",
        text: _this.props.alignment.getSequences(_this.props.sortBy ? _this.props.sortBy : defaultProps.sortBy).map(function (x) {
          return x.id;
        }).join("\n"),
        fontSize: _this.props.zoomLevel ? _this.props.zoomLevel : defaultProps.zoomLevel,
        editorLoaded: function editorLoaded(editor, parentElem) {
          _this.aceEditorLoaded(ACE_EDITOR_IDS.MSA_IDS, editor, parentElem, ScrollSync_1.ScrollType.vertical);
        }
      }));
    };
    _this.state = {
      aceEditors: {},
      aceCharacterWidth: 0,
      windowWidth: window.innerWidth
    };
    _this.verticalScrollSync = new ScrollSync_1.ScrollSync(ScrollSync_1.ScrollType.vertical);
    _this.horizontalScrollSync = new ScrollSync_1.ScrollSync(ScrollSync_1.ScrollType.horizontal);
    _this.minimapClicked = _this.minimapClicked.bind(_assertThisInitialized(_this));
    _this.minimapRectHighlightMoved = _this.minimapRectHighlightMoved.bind(_assertThisInitialized(_this));
    _this.handleCharacterSizeChanged = _this.handleCharacterSizeChanged.bind(_assertThisInitialized(_this));
    _this.aceEditorLoaded = _this.aceEditorLoaded.bind(_assertThisInitialized(_this));
    _this.windowDimensionsUpdated = _this.windowDimensionsUpdated.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(AlignmentViewer, [{
    key: "handleCharacterSizeChanged",
    value: function handleCharacterSizeChanged(newCharSize) {
      if (this.state.aceCharacterWidth !== newCharSize) {
        this.setState({
          aceCharacterWidth: newCharSize
        });
      }
    }
    /**
     * Handle new ace editor. Add it to scroll sync.
     * @param id
     * @param editor
     * @param parentElem
     * @param scrollSyncDirection
     */
  }, {
    key: "aceEditorLoaded",
    value: function aceEditorLoaded(id, editor, parentElem, scrollSyncDirection) {
      var _this2 = this;
      if (scrollSyncDirection === ScrollSync_1.ScrollType.horizontal || scrollSyncDirection === ScrollSync_1.ScrollType.both) {
        this.horizontalScrollSync.registerAceScroller(editor, parentElem);
      }
      if (scrollSyncDirection === ScrollSync_1.ScrollType.vertical || scrollSyncDirection === ScrollSync_1.ScrollType.both) {
        this.verticalScrollSync.registerAceScroller(editor, parentElem);
      }
      this.setState(function (startState) {
        var newAceEditors = Object.assign({}, startState.aceEditors);
        newAceEditors[id] = editor;
        return {
          aceCharacterWidth: editor.renderer.characterWidth,
          aceEditors: newAceEditors
        };
      });
      //track visible rows to show in canvas MSA
      if (id === ACE_EDITOR_IDS.MSA_SEQUENCES) {
        editor.renderer.on("afterRender", function () {
          // BREAKS LOGO, rerenders everything below and kills performance. React lifecycle stuff.
          //setTimeout(() => {
          _this2.setState({
            msaEditorVewport: {
              numberVisibleRows: editor.renderer.getLastFullyVisibleRow() - editor.renderer.getFirstFullyVisibleRow() + 1,
              firstFullyVisibleRow: editor.renderer.getFirstFullyVisibleRow(),
              lastFullyVisibleRow: editor.renderer.getLastFullyVisibleRow()
            }
          });
          //});
        });
      }
    }
    /**
     * React to window dimension changes
     */
  }, {
    key: "windowDimensionsUpdated",
    value: function windowDimensionsUpdated() {
      this.setState({
        windowWidth: window.innerWidth
      });
    }
    /**
     * scroll the aceEditors to a specific position when user clicks on the minimap
     * the editor should center around the click, which will be calculated here.
     *
     * TODO: this might be better delt with in the scroll sync class and only have
     *       one of the editors deal with the rectangles. It works fine right now
     *       when there is only one vertical scroll sync and the minimap widget
     *       spans the entire row, but it will be trickier if e.g., we have
     *       the rectangle take up only the visible horizontal space also.
     *
     * @param mousePosition
     */
  }, {
    key: "minimapClicked",
    value: function minimapClicked(mousePosition) {
      var _this$state = this.state,
        aceEditors = _this$state.aceEditors,
        msaEditorVewport = _this$state.msaEditorVewport; //the ace editor should center around the click. calculate height
      var numRowsVisibleInAceEditor = msaEditorVewport ? msaEditorVewport.numberVisibleRows : 0;
      var newY = Math.round(mousePosition.y - numRowsVisibleInAceEditor / 2);
      newY = newY < 0 ? 0 : newY;
      if (aceEditors[ACE_EDITOR_IDS.MSA_SEQUENCES] !== undefined) {
        aceEditors[ACE_EDITOR_IDS.MSA_SEQUENCES].scrollToRow(newY);
      }
      if (aceEditors[ACE_EDITOR_IDS.MSA_IDS] !== undefined) {
        aceEditors[ACE_EDITOR_IDS.MSA_IDS].scrollToRow(newY);
      }
    }
    /**
     * scroll to specific position when user moves the highlight indicator on minimap
     * by dragging the rectangle itself.
     *
     * TODO: this might be better delt with in the scroll sync class and only have
     *       one of the editors deal with the rectangles. It works fine right now
     *       when there is only one vertical scroll sync and the minimap widget
     *       spans the entire row, but it will be trickier if e.g., we have
     *       the rectangle take up only the visible horizontal space also.
     */
  }, {
    key: "minimapRectHighlightMoved",
    value: function minimapRectHighlightMoved(rectBounds, mousePosition) {
      var aceEditors = this.state.aceEditors;
      if (aceEditors[ACE_EDITOR_IDS.MSA_SEQUENCES] !== undefined) {
        aceEditors[ACE_EDITOR_IDS.MSA_SEQUENCES].scrollToRow(rectBounds.y);
      }
      if (aceEditors[ACE_EDITOR_IDS.MSA_IDS] !== undefined) {
        aceEditors[ACE_EDITOR_IDS.MSA_IDS].scrollToRow(rectBounds.y);
      }
    }
    /*
     *
     *
     * RENDER DIFFERENT COMPONENTS
     *
     *
     */
    /**
     * Generate a single widget that contains an annotation and content
     * @param className
     * @param annotation
     * @param content
     * @param addAsElementToScrollSync
     */
  }, {
    key: "renderWidget",
    value: function renderWidget(className, annotation, content, addAsElementToScrollSync, key) {
      var _this3 = this;
      return react_1.default.createElement("div", {
        className: "av-widget ".concat(className),
        key: key
      }, react_1.default.createElement("div", {
        className: "av-annotation"
      }, annotation), react_1.default.createElement("div", {
        className: "av-content",
        ref: function ref(e) {
          if (e && addAsElementToScrollSync) {
            //TODO: move into separate component .. Ref can be null here and
            //      also good to keep track of removal / addition for scroll sync
            //console.log("the ref is:", e);
            _this3.horizontalScrollSync.registerElementScroller(e);
          }
        }
      }, content));
    }
  }, {
    key: "renderMiniMap",
    value: function renderMiniMap() {
      var _this$props2 = this.props,
        alignment = _this$props2.alignment,
        showMinimap = _this$props2.showMinimap,
        sortBy = _this$props2.sortBy,
        style = _this$props2.style;
      var msaEditorVewport = this.state.msaEditorVewport;
      var mmOptions = this.props.minimapOptions ? this.props.minimapOptions : defaultProps.minimapOptions;
      //const mmClassName = showMinimap ? "minimap" : "minimap hidden";
      return alignment && style && react_1.default.createElement("div", {
        className: "minimap",
        style: {
          display: showMinimap ? "flex" : "none"
        }
      }, react_1.default.createElement(MiniMapComponent_1.MiniMapComponent
      //not exposed to instantiator
      , {
        //not exposed to instantiator
        alignment: alignment,
        alignmentStyle: style,
        sortBy: sortBy ? sortBy : defaultProps.sortBy,
        highlightRows: !msaEditorVewport ? undefined : {
          rowStart: msaEditorVewport.firstFullyVisibleRow,
          rowEnd: msaEditorVewport.lastFullyVisibleRow
        },
        //exposed by prop to instantiator
        alignHorizontal: mmOptions.alignHorizontal,
        resizable: mmOptions.resizable,
        startingWidth: mmOptions.startingWidth,
        verticalHeight: mmOptions.verticalHeight,
        //not exposed yet to instantiator, but should in the future
        onClick: this.minimapClicked,
        onIndicatorDrag: this.minimapRectHighlightMoved
      }));
    }
    /*
     *
     *
     * REACT FUNCTIONS
     *
     *
     */
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.windowDimensionsUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.windowDimensionsUpdated);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        alignment = _this$props3.alignment,
        barplots = _this$props3.barplots,
        showAnnotations = _this$props3.showAnnotations,
        showConsensus = _this$props3.showConsensus,
        showQuery = _this$props3.showQuery,
        showRuler = _this$props3.showRuler;
      if (!alignment) {
        return null;
      }
      var classes = ["alignment-viewer"];
      if (!showAnnotations) {
        classes.push("annotation-closed");
      }
      return react_1.default.createElement("div", {
        className: classes.join(" ")
      }, this.renderMiniMap(), !barplots || barplots.length < 1 ? null : barplots.map(function (barplot, idx) {
        return _this4.renderWidget("av-barplot-holder", barplot.dataSeriesSet.map(function (series) {
          return series.name;
        }).join(" / "), _this4.renderBarplot(barplot), true, "".concat(idx, "-").concat(barplot.dataSeriesSet.map(function (dataseries) {
          return dataseries.id;
        }).join("|")));
      }), !this.props.showLogo || !this.props.logoOptions ? null : this.renderWidget("av-sequence-logo-holder", "Logo:", this.renderSequenceLogo(), true), !showConsensus ? null : this.renderWidget("av-consensus-seq-holder", "Consensus:", this.renderConsensusQueryBox()), !showQuery ? null : this.renderWidget("av-query-seq-holder", "Query:", this.renderQuerySeqBox()), !showRuler ? null : this.renderWidget("av-position-indicator-holder", "Position:", this.renderPositionBox()), this.renderWidget("av-ace-msa-holder", this.renderAlignmentAnnotationBox(), this.renderAlignmentBox()));
    }
  }]);
  return AlignmentViewer;
}(react_1.default.Component);
exports.AlignmentViewer = AlignmentViewer;
AlignmentViewer.defaultProps = defaultProps;